import PAApi from './_paApi.js';

class PAEmployeeHistoryAPI extends PAApi {
  constructor() {
    super();
  }
  controllerName = 'PAEmployeeHistorys';
}

export default new PAEmployeeHistoryAPI();
